import browser from "webextension-polyfill";
import { executeIPMCommands } from "./command-library";
import { clearEvents, getPayload } from "./data-collection";
import { getStartInfo } from "./start-info";
import { intervalKey, lastPingKey, pingCountPrefsKey, scheduleName, serverUrlKey, } from "./telemetry.types";
async function processResponse(response) {
    const { logger } = getStartInfo();
    if (!response || !response.ok) {
        const status = (response === null || response === void 0 ? void 0 : response.status) || "no status";
        logger.reportAndLogError(new Error(`Bad response status from IPM server: ${status}`), `[Telemetry]: Bad response status from IPM server: ${status}`);
        return;
    }
    const body = await response.text();
    if (body.length === 0) {
        return;
    }
    try {
        const bodyJSON = JSON.parse(body);
        let commands;
        if (Array.isArray(bodyJSON)) {
            commands = bodyJSON;
        }
        else {
            commands = [bodyJSON];
        }
        await executeIPMCommands(commands);
    }
    catch (error) {
        logger.reportAndLogError(error, "[Telemetry]: Error parsing IPM response.");
    }
}
function incrementPingCount() {
    const { prefs } = getStartInfo();
    const count = prefs.get(pingCountPrefsKey);
    void prefs.set(pingCountPrefsKey, count + 1);
}
export async function sendPing() {
    const { isOptedOut, logger, prefs } = getStartInfo();
    if (await isOptedOut()) {
        return null;
    }
    const lastPingTimestamp = prefs.get(lastPingKey);
    const intervalTime = prefs.get(intervalKey);
    if (Date.now() - lastPingTimestamp < intervalTime) {
        logger.warn("[Telemetry]: Ping time too early, not pinging.");
        return null;
    }
    const payload = await getPayload();
    void clearEvents();
    const url = prefs.get(serverUrlKey);
    if (typeof url !== "string") {
        return null;
    }
    void prefs.set(lastPingKey, Date.now());
    incrementPingCount();
    void fetch(url, {
        method: "POST",
        cache: "no-cache",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    })
        .then(processResponse)
        .catch((error) => {
        logger.reportAndLogError(error, "[Telemetry]: Ping sending failed with error:");
    });
    return payload;
}
export async function getIPMPingCount() {
    const { prefs } = getStartInfo();
    await prefs.untilLoaded;
    return prefs.get(pingCountPrefsKey);
}
export async function start() {
    const { addMessageListener, prefs } = getStartInfo();
    addMessageListener("ipm:testing.ping_ipm_server", async () => {
        return await sendPing();
    });
    await prefs.untilLoaded;
    const intervalTime = prefs.get(intervalKey);
    if (typeof intervalTime !== "number") {
        return;
    }
    browser.alarms.onAlarm.addListener((alarm) => {
        if (alarm.name !== scheduleName) {
            return;
        }
        void sendPing();
    });
    browser.alarms.create(scheduleName, {
        periodInMinutes: intervalTime / 1000 / 60,
    });
    void sendPing();
}
